export const debounce = function debounce(fn, delay) {
  let timeoutID = null;

  return function() {
    clearTimeout(timeoutID);
    let args = arguments;
    let that = this;

    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
};

export const get = (object, path, defaultValue = null) =>
  path.split('.').reduce((xs, x) => (xs && xs[x]) ? xs[x] : defaultValue, object);

/**
 * Performs a deep merge of `source` into `target`.
 * Mutates `target` only but not its objects and arrays.
 *
 * @author inspired by [jhildenbiddle](https://stackoverflow.com/a/48218209).
 */
export const merge = (target, source) => {
  const isObject = (obj) => obj && typeof obj === 'object';

  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  Object.keys(source).forEach(key => {
    const targetValue = target[key];
    const sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = merge(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });

  return target;
};

/**
 * Document ready for pure js
 * src: https://stackoverflow.com/questions/9899372
 * @param fn
 */
export const onDocumentReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};
